import {
  CreateOutlookImportPayload,
  OutlookAttachmentItem,
  OutlookImportAttachmentResult,
  OutlookImportMessageGroup,
  response,
} from "../models";
import { ApiClient } from "../network/ApiClient";
import { ApiEndpoints } from "../network/ApiEndpoints";

class OutlookService {
  public async getMessageAttachments(
    messageId: string
  ): Promise<OutlookAttachmentItem[]> {
    const res = await ApiClient.get<response>(
      ApiEndpoints.getOutlookMessageAttachments(messageId)
    );
    // The attachment list is the modal's primary data: an unexpected payload
    // shape must surface as an error (the caller shows its error state),
    // not render as a misleading "this email has no attachments".
    if (!Array.isArray(res?.data)) {
      throw new Error(
        `Unexpected response while fetching outlook attachments for message ${messageId}`
      );
    }
    return res.data;
  }

  public async getImports(
    conversationId: string
  ): Promise<OutlookImportMessageGroup[]> {
    const res = await ApiClient.get<response>(ApiEndpoints.getOutlookImports(), {
      conversationId,
    });
    // Tolerate an unexpected payload shape: this lookup only enriches the
    // already-imported markers, so an empty list is a safe degradation.
    return Array.isArray(res?.data) ? res.data : [];
  }

  public async createImport(
    payload: CreateOutlookImportPayload
  ): Promise<OutlookImportAttachmentResult[]> {
    const res = await ApiClient.post<CreateOutlookImportPayload, response>(
      ApiEndpoints.createOutlookImports(),
      payload
    );
    // A non-array payload yields no per-attachment results, which the caller
    // already treats as "everything in this batch failed, retry available".
    return Array.isArray(res?.data) ? res.data : [];
  }
}

const outlookService = new OutlookService();
export { outlookService as OutlookService };
